import { apiClient } from "helpers/api_helper";

export const GetInterStoreOderRequestList = async (data:object) => {
    try {
        const response = await apiClient.get('/api/v1/InterStoreTransfer/GetInterStoreOderRequestList', data)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const CancelInterstoreOrder = async (id : number) => {
    try {
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/CancelInterstoreOrder?id=${id}`)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const UpdateInterStoreOrderStatus = async (data: { id: number; status: string }) => {
    try {
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/UpdateInterStoreOrderStatus?id=${data.id}&status=${data.status}`)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}